+<template>
  <div class="page-wrapper">
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 align-self-center">
          <h4 class="text-themecolor">Task</h4>
        </div>
        <div class="col-md-7 align-self-center text-right">
          <div class="d-flex justify-content-end align-items-center">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="javascript:void(0)">Home</a>
              </li>
              <li class="breadcrumb-item active">Task</li>
            </ol>
          </div>
        </div>
      </div>
      <div class="row justify-content-start" style="margin-bottom: 10px">
        <div class="col-sm-4" style="margin-top: -18px !important">
          <label class="boldText" style="margin-bottom: 0px !important"
            >Status</label
          >
          <MultiSelect
            class="AuditMultiSelect"
            display="chip"
            v-model="SelectedTasksStatus"
            :options="TasksStatus"
            optionLabel="name"
            optionGroupLabel="labelName"
            optionGroupChildren="tasksStatuses"
            placeholder="Search By Task Status"
            @change="getTableData()"
          />
        </div>
        <div class="col-sm-4" style="margin-top: -18px !important">
          <label class="boldText" style="margin-bottom: 0px !important"
            >User</label
          >
          <MultiSelect
            class="AuditMultiSelect"
            v-model="SelectedUsers"
            :options="Users"
            optionLabel="name"
            optionGroupLabel="label"
            optionGroupChildren="userTaskListsActive"
            placeholder="Search By Users"
            display="chip"
            @change="getTableData()"
          />
        </div>
        <div class="col-sm-4" style="margin-top: -18px !important">
          <label class="boldText" style="margin-bottom: 0px !important"
            >Date</label
          >
          <br />
          <input
            style="width: 95%; height: 64%"
            type="text"
            name="daterangePR"
            :value="initDatePR"
            @change="datePickerPR"
            @focus="datePickerPR"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-sm-4">
          <div class="text-right d-flex justify-content-end">
            <button
              class="btn btn-success waves-effect mt-2 mb-2"
              type="button"
              @click="ShowTaskAddTo()"
            >
              <i class="fas fa-plus"></i>
            </button>

            <div class="dropdown">
              <button
                class="btn btn-danger waves-effect mt-2 mb-2 ml-3"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-solid fa-sort-down"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                  style="padding: 0.65rem 1.5rem;cursor:pointer"
                  @click="OpenMassUpdateDialog()"
                >
                  Mass Update
                </div>
              </div>
            </div>
            <!------------------------------------  Mass Update Dialog ------------------------------------------>
            <Dialog
              v-model:visible="MassUpdateDialog"
              modal
              showHeader="false"
              header="Mass Update"
              :style="{ width: '30vw' }"
              :breakpoints="{ '960px': '75vw', '641px': '100vw' }"
            >
              <form>
                <div class="form-group">
                  <label for="comment-text" class="control-label"
                    >Select field:</label
                  >
                  <select
                    class="form-control custom-select AuditMultiSelect"
                    tabindex="1"
                    v-model="MassUpdateFormSelectedValue"
                  >
                    <option value="0">Choose field</option>
                    <option value="1">Status</option>
                  </select>
                </div>
                <div
                  class="form-group"
                  v-if="MassUpdateFormSelectedValue === '1'"
                >
                  <label for="comment-text" class="control-label"
                    >Select Status:</label
                  >

                  <Dropdown
                    class="AuditMultiSelect"
                    display="chip"
                    v-model="MassUpdateValue"
                    :options="TasksStatus"
                    optionLabel="name"
                    optionGroupLabel="labelName"
                    optionGroupChildren="tasksStatuses"
                    placeholder="Search By Task Status"
                  />
                </div>
              </form>
              <button
                :disabled="MassUpdateValue == 0"
                type="button"
                @click="UpdateMassForm"
                class="btn btn-outline-success waves-effect waves-light col-12 mass_update"
              >
                Update
              </button>
            </Dialog>
          </div>
        </div>
      </div>
      <div class="card p-3" ref="tableLoad">
        <div
          class="table-responsive"
          style="min-height: 500px; overflow: overlay;"
        >
          <div
            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
          >
            <div class="dataTables_length">
              <span style="margin-right: 10px"
                ><label for="">Show </label>
              </span>
              <select
                v-model="pageSize"
                class="form-control form-control-sm"
                aria-label="Default select example"
                @change="pageChange(1)"
              >
                <option selected>50</option>
                <option value="100">100</option>
                <option value="500">500</option>
              </select>

              <span style="margin-left: 10px">
                <label for=""> Entries </label></span
              >
            </div>
            <div class="dataTables_filter">
              <span class="float-right">
                <span style="margin-right: 10px"
                  ><label for="Search">Search:</label></span
                >
                <input
                  type="text"
                  @change="SearchDataTable()"
                  v-model="search"
                  name=""
                  id=""
                />
              </span>
            </div>
          </div>
          <table
            data-height="300"
            class="table display table-bordered text-center table-striped no-wrap"
            id="example23"
          >
            <thead class="thead-dark">
              <tr>
                <th>
                  Task ID
                  <span
                    ><button class="asc-desc-btn" @click="orderBy(0)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Task Name
                  <span
                    ><button class="asc-desc-btn" @click="orderBy(1)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Referance ID
                  <span
                    ><button class="asc-desc-btn" @click="orderBy(2)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Patient Name<span
                    ><button class="asc-desc-btn" @click="orderBy(3)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Date Of Service<span
                    ><button class="asc-desc-btn" @click="orderBy(4)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>Due Date</th>
                <th>Assign To</th>
                <th>
                  Assign by<span
                    ><button class="asc-desc-btn" @click="orderBy(5)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Status<span
                    ><button class="asc-desc-btn" @click="orderBy(5)">
                      ↑ ↓
                    </button></span
                  >
                </th>
              </tr>
            </thead>
            <tbody v-if="totalPages == 0 && totalRows == 0">
              <td valign="top" colspan="9" class="dataTables_empty">
                No matching records found
              </td>
            </tbody>
            <tbody v-else>
              <tr v-for="(pt, index) in PatientTasks" :key="index">
                <td>
                  <span>
                    <a
                      @click="getAuditLogByVisitTaskIdAndTaskId(pt)"
                      href="javascript:void(0)"
                      class=""
                      style="margin-right: 5px"
                    >
                      <i class="fas fa-bell text-success"></i
                    ></a>
                  </span>
                  <span>
                    <a
                      href="javascript:void(0)"
                      @click="deleteVisitTaskSwal(pt)"
                    >
                      <i
                        class="fa fa-trash"
                        aria-hidden="true"
                        style="
                          font-size: 15px;
                          margin-top: 0px;
                          color: rgb(255, 102, 102);
                        "
                      >
                      </i>
                    </a>
                  </span>
                  {{ pt.visitTaskIdSerial }}
                </td>
                <td>
                  <!-- <span v-tooltip:top> -->
                  <a href="javascript:void(0)" class="mytooltip">
                    <span
                      v-if="pt.taskNameCheckin.length > 20"
                      class="tooltip-content5 custom-tooltip"
                      style="width: fit-content"
                    >
                      <span class="tooltip-text3">
                        <span class="tooltip-inner2">
                          <div class="timeline-panel">
                            <div
                              class="timeline-heading custom-timeline-heading"
                            >
                              <p class="timeline-title custom-timeline-title">
                                {{ pt.taskNameCheckin }}
                              </p>
                            </div>
                          </div>
                        </span>
                      </span>
                    </span>
                    <input
                      type="text"
                      maxlength="250"
                      class="trans-input"
                      v-model="pt.taskNameCheckin"
                      @keydown="
                        TaskNameUpdatedIcon($event, pt.taskNameCheckin, pt)
                      "
                      @keydown.enter="
                        TaskNameUpdated($event, pt.taskNameCheckin, pt)
                      "
                      @change="
                        TaskNameUpdatedIcon($event, pt.taskNameCheckin, pt)
                      "
                    /><span v-if="pt.taskNameCheckin.length > 20">...</span>
                    <button
                      class="save-icon-button"
                      v-if="pt.inputNameIcon == true"
                    >
                      <span
                        class="saveiconfile2"
                        style="font-size:22px;margin-top: 6px;padding-left: 4px;"
                        @click="TaskNameUpdated($event, pt.taskNameCheckin, pt)"
                      ></span>
                    </button>
                  </a>
                  <!-- </span> -->
                </td>
                <td>{{ pt.vid }}</td>
                <td>
                  <span v-if="pt.patientId != 0 || pt.patientId == null">{{
                    pt.patientName + " - " + pt.ptid
                  }}</span>
                </td>
                <td>
                  {{ pt.dosStr }}
                </td>
                <td>
                  <!-- Due Date -->
                  <div class="input-group mb-3">
                    <input
                      v-model="pt.dueDateStr"
                      type="date"
                      class="form-control"
                      placeholder="Select Date"
                      @change="ChangeTaskDueDateIcon(pt, pt.dueDateStr)"
                      @keydown.enter="ChangeTaskDueDate(pt, pt.dueDateStr)"
                    />
                    <button
                      class="save-icon-button"
                      v-if="pt.dateChangeIcon == true"
                    >
                      <span
                        class="saveiconfile2"
                        style="font-size:22px;margin-top: 6px;padding-left: 4px;"
                        @click="ChangeTaskDueDate(pt, pt.dueDateStr)"
                      ></span>
                    </button>
                  </div>
                </td>
                <td class="" style="max-width: 600px; ">
                  <div class="row justify-content-center">
                    <div class="col-xs-12 d-flex align-items-center">
                      <i
                        v-if="pt.userSelected.includes(userid)"
                        class="fas fa-user float-left user-color pr-2"
                      ></i>
                      <div>
                        <MultiSelect
                          :showClear="true"
                          :filter="true"
                          class="multi-select-assign-to"
                          filterMatchMode="startsWith"
                          v-model="pt.userSelected"
                          :options="pt.userList"
                          option-label="name"
                          optionValue="userId"
                          placeholder="Select a Users"
                          appendTo="self"
                          display="chip"
                          :loading="pt.loading"
                          @change="
                            AddRemoveUser(
                              $event,
                              pt.userSelected,
                              pt.userList,
                              pt
                            )
                          "
                          @hide="
                            sortUsersSelected(pt.userList, pt.userSelected)
                          "
                          @show="
                            sortUsersSelected(pt.userList, pt.userSelected)
                          "
                        >
                          <template #option="slotProps">
                            <div class="">
                              <p>{{ "" + slotProps.option.name }}</p>
                            </div>
                          </template>
                        </MultiSelect>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  {{ pt.assignByIdName }}
                  <br />{{ pt.assignByDateStr }}
                </td>
                <td tabindex="1">
                  <a
                    @click="getComment(pt.visitTaskId, pt)"
                    href="javascript:void(0)"
                    data-target="#commentModal"
                    data-toggle="modal"
                    class="mytooltip"
                  >
                    <img
                      v-if="pt.comment <= 0"
                      src="assets/images/actions/comment-grey.png"
                      alt="Comment Left"
                      class="action_icon"
                    />
                    <img
                      v-else
                      src="assets/images/actions/comment.png"
                      alt="Comment Left"
                      class="action_icon"
                    />
                    <span
                      v-if="pt.taskComment != undefiend"
                      class="tooltip-content5 custom-tooltip"
                    >
                      <span class="tooltip-text3">
                        <span class="tooltip-inner2">
                          <div class="timeline-panel">
                            <div
                              class="timeline-heading custom-timeline-heading"
                            >
                              <p class="timeline-title custom-timeline-title">
                                {{ pt.taskComment.comment }}
                              </p>
                              <h4>{{ pt.taskComment.userName }}</h4>
                              <p class="custom-para">
                                <small class="text-muted">
                                  <i class="fa fa-clock-o"></i
                                  >{{ pt.taskComment.createdDateStr }}
                                </small>
                              </p>
                            </div>
                          </div>
                        </span>
                      </span>
                    </span>
                    <span v-else class="tooltip-content5 custom-tooltip">
                      <span class="tooltip-text3">
                        <span class="tooltip-inner2">
                          <div class="timeline-panel">
                            <div
                              class="timeline-heading custom-timeline-heading"
                            >
                              <p class="timeline-title custom-timeline-title">
                                No Comments Left
                              </p>
                            </div>
                          </div>
                        </span>
                      </span>
                    </span>
                  </a>
                  <Dropdown
                    filterMatchMode="startsWith"
                    v-model="pt.taskStatus"
                    :options="convertItInSortAndGroupList(pt.taskStatusList)"
                    :panelStyle="{ width: '100px' }"
                    style="text-align: left"
                    optionLabel="statusName"
                    optionGroupLabel="statusName"
                    optionGroupChildren="items"
                    optionValue="taskStatusId"
                    placeholder="Select a Status"
                    appendTo="self"
                    class="m-b-10"
                    @change="ChangeTaskStatus(pt, pt.taskStatus)"
                  >
                    <template #option="slotProps">
                      <div :title="slotProps.option.statusName">
                        {{ slotProps.option.statusName }}
                      </div>
                    </template>
                    <template #optiongroup="slotProps">
                      <div>{{ slotProps.option.label }}</div>
                    </template>
                  </Dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <nav aria-label="Page navigation" style="float: right">
          <span
            style="padding-left: 40px"
            v-if="totalRows < pageSize * pageNumber"
            >showing {{ totalRows }} of {{ totalRows }} records</span
          >
          <span style="padding-left: 40px" v-else
            >showing {{ pageSize * pageNumber }} of
            {{ totalRows }} records</span
          >
          <ul class="pagination" style="float: right">
            <li class="page-item colorActive">
              <span v-if="pageNumber == 1">
                <button
                  disabled
                  class="page-link disabledColor"
                  @click="pageChange('Previous')"
                >
                  Previous
                </button>
              </span>
              <span v-else>
                <button class="page-link" @click="pageChange('Previous')">
                  Previous
                </button>
              </span>
            </li>
            <!--show pagination-->
            <li v-if="showPagesMin > 1">
              <button class="page-link" @click="pageChange(1)">1</button>
            </li>
            <li v-if="showPagesMin > 1">
              <button disabled class="page-link disabledColor">...</button>
            </li>
            <!--show pagination-->
            <li
              v-for="pageNum in totalPages"
              :key="pageNum"
              class="page-item colorActive"
            >
              <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax">
                <span v-if="pageNumber == pageNum"
                  ><button
                    class="page-link activeColor"
                    disabled
                    @click="pageChange(pageNum)"
                  >
                    {{ pageNum }}
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange(pageNum)">
                    {{ pageNum }}
                  </button></span
                >
              </span>
            </li>

            <!--show pagination-->
            <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
              <button disabled class="page-link disabledColor">...</button>
            </li>
            <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
              <button class="page-link" @click="pageChange(totalPages)">
                {{ totalPages }}
              </button>
            </li>
            <!--show pagination-->
            <li class="page-item colorActive">
              <span v-if="pageNumber == totalPages">
                <button
                  disabled
                  class="page-link disabledColor"
                  @click="pageChange('Next')"
                >
                  Next
                </button>
              </span>
              <span v-else>
                <button class="page-link" @click="pageChange('Next')">
                  Next
                </button>
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
    <!-- Add Task Status Modal -->
    <Dialog
      :autoZIndex="true"
      :draggable="false"
      v-model:visible="AddTaskStatusModal"
      :modal="true"
      appendTo="body"
      style="width: 30%; max-height: max-content"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Add A Status</h4>
      </template>
      <div class="modal-body mb-1 pt-2" id="mydiv">
        <TaskStatusAddComponent
          :patientTask="currentPatientTask"
          :changeTaskStatus="ChangeTaskStatusAxios"
          :tableRefreash="getTableData"
          :closeModal="closeTaskStatus"
        ></TaskStatusAddComponent>
      </div>
    </Dialog>
    <!-- Add Task Status Modal -->

    <!-- audit Log modal -->
    <Dialog
      header="History"
      v-model:visible="displayAuditLog"
      :modal="true"
      :draggable="false"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '60vw' }"
    >
      <AuditLogComponent ref="auditLogComponent" :isModel="true">
      </AuditLogComponent>
    </Dialog>
    <TaskAuditLog></TaskAuditLog>

    <!-- audit Log modal -->

    <!-- Add Task Model -->
    <Dialog
      :autoZIndex="true"
      :draggable="false"
      v-model:visible="AddTaskModal"
      :modal="true"
      appendTo="body"
      style="width: 30%; max-height: max-content"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Add A Task</h4>
      </template>
      <div class="modal-body mb-1 pt-2" id="mydiv">
        <TaskAddToComponent
          :tableCall="getTableData"
          :closeModal="CloseTaskAddTo"
          ref="taskAddTo"
        ></TaskAddToComponent>
      </div>
    </Dialog>
    <!-- Add Task Model -->
    <!-- ============================================================== -->

    <!-- comment Modal -->
    <div
      id="commentModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Leave a reply</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <TaskCommentComponent
              ref="taskComment"
              :patientTask="patientTask"
              :tableRefreash="getTableDataWithOutLoad"
            ></TaskCommentComponent>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
    <!-- comment Modal -->
  </div>
  <!-- ============================================================== -->
  <!-- End Page wrapper  -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- End Wrapper -->
  <!-- ============================================================== -->
</template>

<script src="./PatientTask.js"></script>
<style src="../../../public/assets/CSS/saveiconfile.css"></style>
<style scoped>
.dropdown-menu {
  left: -3rem !important;
}
.AuditMultiSelect {
  width: 100%;
}

.multi-select-assign-to {
  margin-top: 10px;
  width: 380px;
}

:deep(.p-dropdown-panel) {
  left: -50px !important;
  min-width: 100%;
  width: 200px;
}

/* :deep(.p-multiselect-label) {
  width: fit-content;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  font-size: 13px;
}
 :deep(.p-multiselect-token) {
    padding: 0.25rem 0.5rem;
    margin: 1px;
    margin-right: 0rem;
    background: #dee2e6;
    color: #495057;
    border-radius: 16px;
} */

#font1 {
  font-weight: bold;
}

.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}

.save-icon-color {
  color: yellow;
}

.colorActive {
  color: #f95c2e;
}

.user-color {
  color: green;
}

.activeColor {
  background-color: #fb9678;
  color: white;
}

.action_icon {
  height: 20px;
}

.trans-input {
  color: #000000b8;
  text-align: center;
  background: transparent;
  border: none;
}

.p-dialog-mask .p-component-overlay .p-component-overlay-enter {
  z-index: 899;
}
</style>
